import React, {useContext} from 'react';
import {Typography} from 'onboarding-components';
import clsx from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';
import {useTranslation} from 'common/i18n/hooks';
import {InviteTeammateButton} from 'iron/common/onboarding/immersive-onboarding/components/invite-teammate-btn';
import {VisibilityContext} from 'common/onboarding/immersive-onboarding/types';

import styles from '../index.module.styl';

type HeaderProps = {
  imgSrc?: string;
  title: string;
  step: string;
  duration?: number;
  completed?: boolean;
  showCloseBtn?: boolean;
  onClose?: () => void;
  showInviteBanner?: boolean;
};

export const Header = ({
  showInviteBanner,
  imgSrc,
  title,
  step,
  duration,
  completed,
  showCloseBtn = true,
  onClose,
}: HeaderProps) => {
  const {t} = useTranslation();
  const {setVisibility} = useContext(VisibilityContext);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.title}>
          {imgSrc && <img src={imgSrc} height={60} />}
          <div>
            <Typography variant='eyebrowSm' className={styles.step}>
              {step}
            </Typography>
            <Typography variant='headingSm' style={{margin: 0}}>
              {title}
            </Typography>
          </div>
        </div>

        {!showCloseBtn && completed ? (
          <Typography variant='bodySm' className={clsx(styles.time, {[styles.completed]: completed})}>
            {completed ? (
              <>
                <SvgIconReact icon={`checkmark`} color={`#07B096`} />
                {t(`onboarding.completed`)}
              </>
            ) : (
              duration && <div>{t(`onboarding.completion-duration`, {count: duration})}</div>
            )}
          </Typography>
        ) : (
          <button onClick={onClose} className={clsx(styles.btnReset, styles.closeBtn)}>
            <div className={styles.closeBtnBox}>
              <Typography variant='captionXs' weight='bold' className={styles.closeBtnText}>
                {t(`common.close`)}
              </Typography>
              <SvgIconReact icon={`x`} />
            </div>
          </button>
        )}
      </div>
      {showInviteBanner && (
        <div className={styles.inviteBanner}>
          <div>
            <Typography variant='captionXs'>
              <span style={{fontWeight: 500}}>{t(`onboarding.invite-banner.need-help`)}</span>
              {` `}
              {t(`onboarding.invite-banner.invite-your-team`)}
            </Typography>
          </div>
          <div>
            <InviteTeammateButton setVisibility={setVisibility} className={clsx(styles.btnReset, styles.inviteBtn)}>
              <Typography variant='captionXs' weight='bold'>
                {t(`onboarding.invite-banner.button-text`)}
              </Typography>
            </InviteTeammateButton>
          </div>
        </div>
      )}
    </>
  );
};
